import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form } from 'antd';
import React, { useState } from 'react';
import { EXPORT_TYPES, MODULES } from '../../../../../common/constants';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import DamageTable from '../components/DamageTable';
import LibraryTabs from '../components/LibraryTabs';
import { REQUEST_LIBRARY_REQUESTS_EXPORT } from '../graphql/Mutations';

const Damages = () => {
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestLibraryRequestsExport] = useMutation(
    REQUEST_LIBRARY_REQUESTS_EXPORT,
    {
      onError: () => {},
    },
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestLibraryRequestsExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.LIBRARY_DAMAGE,
        },
        filter: {
          search: exportFilter?.search,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          status:
            exportFilter?.status?.length > 0 ? exportFilter?.status : undefined,
          libraryIds: exportFilter?.name,
          isArchived: exportFilter?.isArchived,
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.LIBRARY}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <LibraryTabs>
        <div className="tab-table">
          <DamageTable
            exportFilter={exportFilter}
            setExportFilter={setExportFilter}
          />
        </div>
      </LibraryTabs>
    </>
  );
};

export default Damages;
